import { render, staticRenderFns } from "./NotepadPopup.vue?vue&type=template&id=123c83b1&lang=html"
import script from "./NotepadPopup.vue?vue&type=script&lang=js"
export * from "./NotepadPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports